<template>
  <div v-if="show" class="pop" @touchmove="touchmove">
    <div class="pop-bg" @touchstart="cancel"></div>
    <div class="modal">
      <div class="modal-title">
        <slot name="title"></slot>
      </div>
      <div class="modal-content">
        <slot></slot>
      </div>
      <div class="modal-foot">
        <div class="modal-button" @click="cancel">取消</div>
        <div class="modal-button button-parimary" @click="confirm">确定</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    content: String,
    show: Boolean
  },
  methods:{
    cancel(){
      this.$emit('update:show', false)
    },
    confirm(){
      this.$emit("confirm", false)
    },
    touchmove(e){
      var event = e || event;
      event.preventDefault()
      event.stopPropagation()
    }
  }
}
</script>

<style lang="less">
  .pop{
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1000;
  }
  .pop-bg{
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,0.7);
    z-index: 0;
  }
  .modal{
    width: 80%;
    background: #ffffff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 0.5em;
    overflow: hidden;
  }
  .modal-title{
    text-align: center;
    line-height: 2;
  }
  .modal-content{
    padding: 0.5rem 2rem;
  }
  .modal-foot{
    display: flex;
    width: 100%;
    border-top: 1px solid #ccc;
    .modal-button{
      flex: 1 auto;
      height: 3rem;
      line-height: 3rem;
      text-align: center;
    }
    .button-parimary{
      background-color: #39A6FF;
      color: #ffffff;
    }
  }
</style>